import React, { useEffect, useState, useRef } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "./../../../components/card/card.jsx";
import { matar } from "../../../api/index.js";
import { toast } from "react-toastify";
import { useAuth } from "../../../contexts/AuthContext.jsx";
import { useDashboardContext } from "../../../contexts/NewDashboardContext.jsx";
import { useNavigate, useRoutes } from "react-router-dom";
import Swal from "sweetalert2";
import {
  formatDateOnly,
  generateLocationToArray,
  Loader,
} from "../../../utils/helper";
import DataTable from "react-data-table-component";
import { LocationFilter } from "../../../components/LocationFilter/index.jsx";
import { assetData } from "../data-sample";

function MachineList() {
  const navigate = useNavigate();
  const [datas, setDatas] = useState([]);
  const [groups, setGroups] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState({ company: true });
  const { config } = useAuth();
  const machineTypes = [
    {
      id: "555b1dc5-6983-4501-afdf-474665a3e131",
      name: "Compressor",
    },
    {
      id: "ApronDrive",
      name: "Apron Drive",
    },
    {
      id: "Transformer",
      name: "Transformer",
    },
  ];
  const [deleteRow, setDeleteRow] = useState(null);
  const [changeStatus, setChangeStatus] = useState(null);
  const { updateMachineProfile } = useAuth();
  const canUpdate = updateMachineProfile();
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  async function getData(forcePage) {
    try {
      setLoading(true);
      const queryParam = {
        ...query,
        page: forcePage ? forcePage : page,
      };
      const res = await matar.getStrategy(queryParam);
      if (res.ok) {
        const body = await res.json();
        let data = body.data?.results;
        const totalPage = body.data?.totalPage;
        setTotalPage(totalPage);
        if (data) {
          setDatas(data);
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }

  useEffect(() => {
    // wait for 1 second before calling getData
    const timer = setTimeout(() => {
      if (search) {
        const queryParam = {
          ...query,
          search: search.toUpperCase(),
        };
        setQuery(queryParam);
      } else {
        setQuery({ company: true });
      }
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, [search]);

  useEffect(() => {
    getData();
    getDataGroup();
  }, [page]);
  useEffect(() => {
    setPage(1);
    getData(1);
  }, [query]);

  const columns = [
    {
      name: <div>Strategy Name</div>,
      selector: (row) => row["name"],
      style: { whiteSpace: "unset" },
      minWidth: "200px",
      wrap: true,
      maxWidth: "250px",
    },
    {
      name: "Group Name",
      selector: (row) => row["machine_name"],
      style: { whiteSpace: "unset" },
      minWidth: "250px",
      wrap: true,
      maxWidth: "250px",
      cell: (row) => row?.group?.name,
    },
    {
      name: "Total Asset",
      selector: (row) => row["group"],
      style: { whiteSpace: "unset" },
      wrap: true,
      minWidth: "200px",
      maxWidth: "200px",
      cell: (row) => row?.group?.MachineGroup.length,
    },

    {
      name: <div>Action</div>,
      selector: (row) => row["action"],
      minWidth: "250px",
      maxWidth: "250px",
      cell: (row) => (
        <div className={"d-flex justify-content-between"}>
          <button
            onClick={() => {
              navigate("/machine-asset/financial-detail?strategyId=" + row.id);
            }}
            className="btn btn-sm btn-outline-theme mx-2"
          >
            Edit <i class="fa fa-edit"></i>
          </button>
          <button
            className="btn btn-sm btn-outline-danger mr-2"
            onClick={() => {
              deleteData(row.id);
            }}
          >
            Delete <i class="fa fa-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  async function deleteData(id) {
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoading(true);
          const res = await matar.deleteStrategy({ id });
          if (res.ok) {
            const body = await res.json();
            toast.success(body.message);
            getData();
          } else {
            const body = await res.json();
            toast.error(body.message);
          }
          setLoading(false);
        }
      });
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }
  async function getDataGroup() {
    try {
      setLoading(true);
      const res = await matar.getGroupMatar();
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        setGroups(data);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }

  const handlePageChange = (page) => {
    setPage(page);
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <h3>Financial Strategies</h3>

          <hr className="mb-1" />

          <div id="datatable" className="mb-5">
            <div className="row">
              <div className="col-md-12">
                <button
                  className="btn btn-theme text-black btn-sm  mb-3"
                  onClick={() => {
                    navigate("/machine-asset/financial-detail");
                  }}
                  style={{ marginTop: "22px", marginRight: "10px" }}
                >
                  + Create New Strategy
                </button>
                <Card>
                  <CardBody>
                    <Loader loading={loading}>
                      <DataTable
                        paginationPerPage={20}
                        paginationRowsPerPageOptions={[20]}
                        highlightOnHover
                        theme="dark"
                        columns={columns}
                        data={datas}
                        pagination
                        paginationServer
                        paginationTotalRows={totalPage * 20}
                        onChangePage={handlePageChange}
                      />
                    </Loader>
                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MachineList;
